import { MySiteRestService } from "@nuskin/my-site-api";
import { RunConfigService, util } from "@nuskin/ns-util";
import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import html from "./ns-product-bundle.html";
import { ProductDataService } from "@nuskin/ns-product";
/**
 * <p>The ns-product-bundle is for the customer view of storefront. This component utilizes the ns-product-small component for displaying product data.</p>
 *
 * <h2>UX/Design Docs</h2>
 * <a href="https://nuskin.invisionapp.com/share/J4JFOE0A2S9#/screens/298953869" target="_bank">
 *   InVision Design Document
 * </a>
 *
 * <h2>Demo</h2>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-product-bundle></ns-product-bundle>
 *   </template>
 * </demo-snippet>
 */
export class NsProductBundle extends PolymerElement {
    constructor() {
        super();
    }

    static get is() {
        return "ns-product-bundle";
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = html;
        return htmlElement;
    }

    static get properties() {
        return {
            title: {
                type: String
            },
            description: {
                type: String
            },
            forMySitePreview: {
                type: Boolean
            },
            categoryId: {
                type: String
            },
            /**
             * Translations to override within the template
             */
            translations: {
                type: Object,
                value: {
                    defaultBundleMessage: 'Here is a default bundle message.',
                    items: '{qty} items',
                    addItemsToCart: 'Add items to cart',
                    observer: '_translationsSet'
                }
            },
            /**
             * Default products used in the demo or when no products are passed.
             * This product data is iterated over and passed into the ns-product-small component.
             */
            products: {
                type: Array,
                value: [
                    {
                        "RequestedQuantity": 1,
                        "SKU": "01003750",
                        "name": "ageLOC TR90 JumpStart",
                        "price": 124.5
                    },
                    {
                        "RequestedQuantity": 1,
                        "SKU": "01001457",
                        "name": "Epoch Kasbah Blend",
                        "price": 27
                    },
                    {
                        "RequestedQuantity": 1,
                        "SKU": "01111155",
                        "name": "AP 24&#174;  Whitening Fluoride Toothpaste",
                        "price": 20
                    },
                    {
                        "RequestedQuantity": 1,
                        "SKU": "01101257",
                        "name": "Tru Face&#174; Instant Line Corrector",
                        "price": 66.5
                    },
                    {
                        "RequestedQuantity": 1,
                        "SKU": "01001453",
                        "name": "Epoch Ginger",
                        "price": 40
                    }
                ],
                observer: '_productsUpdated'
            },
            localProducts: {
                type: Array,
                value: [],
            },
            productOutOfStock: {
                type: Boolean,
                value: false
            },
            priceType: {
                type: String
            },
            isMobile: {
                type: Boolean,
                value: false
            },
            classId: {
                type: String,
                value:'bundle-object',
            },
        }
    }

    ready() {
        super.ready();
        this.country = RunConfigService.getRunConfig().country;
        this.language = RunConfigService.getRunConfig().language;
        this.set('basePath', window.location.pathname);
        document.addEventListener('ns-product-small-updated-skus', this.resetMinHeightWidth.bind(this));
        window.addEventListener('resize', this.resetMinHeightWidth.bind(this));
        // Initialize Slick Slider
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.js';
        script.onload = this.scriptLoaded.bind(this); // Callback when script is loaded
        document.head.appendChild(script);
    }

    scriptLoaded() {
        console.log('Script loaded and executed.');
        // this.performFurtherActions();
      }
      
      performFurtherActions() {
        setTimeout(()=>{
            if ($('script[src="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.js"]').length > 0) {
                    // this.initSlick()
              }
        },100)
      }

    resetSlider(event){
        let modalIndex = event.model.__data.index || 0
        let slider = $(this.shadowRoot.querySelector(`.carousel-products-${this.categoryId}`))
        const dotsElement = this.shadowRoot.querySelector('.slick-dots');
        const slickElement = this.shadowRoot.querySelector('.slick-track');
        const transformElement = this.shadowRoot.querySelector('.slick-list');
        if(event.detail.value){
            slickElement.classList.toggle('transition-null');
            slickElement.classList.toggle('transform-none');
            transformElement.classList.toggle('transform-none');
            slider.slick('slickGoTo', 0);
            slider.slick('slickSetOption', 'swipe', false)
            dotsElement.classList.toggle('dots-hidden');
        }else{
            slickElement.classList.toggle('transform-none');
            transformElement.classList.toggle('transform-none');
            slider.slick('slickGoTo', modalIndex)
            slider.slick('slickSetOption', 'swipe', true)
            dotsElement.classList.toggle('dots-hidden');
            setTimeout(()=> {
                slickElement.classList.toggle('transition-null');
            },0)
        }
    }
    initSlick() {
      /* eslint-disable no-undef */
      let slider = $(this.shadowRoot.querySelector(`.carousel-products-${this.categoryId}`))
      let productsCount = this.products.length
      slider.slick({
          dots: true,
          arrows: productsCount > 4 ? true : false,
          infinite: false,
          speed: 300,
          slidesToShow: 4,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                arrows: productsCount > 3 ? true : false,
              }
            },{
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                arrows: false
              }
            }
          ]
      });
    // Remove last two slides
    let sliderCount = slider.slick('getSlick').slideCount;
    const slickElement = this.shadowRoot.querySelector('.slick-track');
    const slickSlideElement = this.shadowRoot.querySelector('.slick-slide');
    window.innerWidth < 768 ?
        this.calculateInnerWidth(1)
    : window.innerWidth < 1024 ?
        this.calculateInnerWidth(3) :
        this.calculateInnerWidth(4)
    const body = document.body;
    const bodyIdAttribute = body.getAttribute('id')
    if(bodyIdAttribute == 'page-mysite-home'){
        slider.slick('slickRemove', sliderCount - 1);
    }else{
        slickElement.classList.add('slick-track-flex')
        if (window.innerWidth < 1024) {
            slickSlideElement.classList.add('slick-list-none')
        }else{
            slickSlideElement.classList.remove('slick-list-none')
        }
    }

    //Disabling View All Button Based on Product Count

    /* eslint-enable no-undef */
    }

    calculateInnerWidth(productLength){
        const categoriesButton = this.shadowRoot.querySelector('.categories-btns');
        if(this.products.length <= productLength){
            categoriesButton.classList.add('slick-list-none')
        }else{
            categoriesButton.classList.remove('slick-list-none')
        }
    }

    _computeButton(isMobile){
        return isMobile ? 'btn-see-all mobile': 'btn-see-all'

    }

    _showCategory() {
        const storeId = JSON.parse(window.sessionStorage.getItem('sponsor'))
        const basePath = window.location.pathname
        const newUrl = basePath + '?storeId='+storeId+'&categoryId='+this.categoryId+'#categories'
        window.location = newUrl
    }

    async connectedCallback() {
        super.connectedCallback();
        this.subdomain = await MySiteRestService.getCurrentSubdomain()
        /*
        Callback is tied to a component attribute so that it can be referenced
        for event listener removal.
        Callback is structured here as arrow function wrapper around actual
        function to protect against 'this' rebinding.
         */
        this._updatePriceCallback = evt => this._updateBundlePrice();
        this.addEventListener('price-updated', this._updatePriceCallback);
    }

    disconnectedCallback() {
        this.removeEventListener('price-updated', this._updatePriceCallback);
        document.removeEventListener('ns-product-small-updated-skus', this.resetMinHeightWidth.bind(this));
        window.removeEventListener('resize', this.resetMinHeightWidth.bind(this));
    }

    // this is done to make sku updates within the budle not 'jumpy' visually
    setMinHeightWidth() {
        this.$.bundleWrapper.style.minHeight = this.$.bundleWrapper.offsetHeight;
        this.$.bundleWrapper.style.minWidth = '400px';
        this.$.productBundle.style.minHeight = this.$.productBundle.offsetHeight;
    }

    resetMinHeightWidth() {
        this.$.bundleWrapper.style.minHeight = 300;
        this.$.bundleWrapper.style.minWidth = '400px';
        this.$.productBundle.style.minHeight = 300;
    }

    /**
     * This function is called from within a dom-repeat with a product sku passed in.
     * @param {string} sku
     * @returns a relative url to the storefront pdp
     */
    getPdpUrl(sku) {
        return util.getLocaleUrl() + "products/product." + sku + ".mysite." + this.subdomain + ".html";
    }
    _onProductChange(e) {
        const template = e.target;
        if (template.items && template.items.length > 0) {
            this.initSlick();
        }
    }

    /**
     * As products are updated in the product bundle list, recalculate the total cost of the bundle
     * This also set the number of products label above the purchase bundle button
     */
    async _productsUpdated() {
        this.setMinHeightWidth();
        try {
          if (!this.products || !Array.isArray(this.products)) return;
          const skus = this.products
            .map((product) => product.SKU)
            .filter((sku) => sku !== undefined);
        //   if (skus && skus.length > 0) {
        //     const data = await ProductDataService.getProductData(skus);
        //     if (data && data.products) {
        //       this.localProducts = data.products.map((product) => {
        //         return {
        //           ...product,
        //           SKU: product.sku,
        //         };
        //       });
        //       //this.set('localProducts',finalProducts);
        //       this.productsLoaded = true;
        //     }
        //   }
        if (skus && skus.length > 0) {
            try {
              const batchSize = 6;
              const results = [];
          
              for (let i = 0; i < skus.length; i += batchSize) {
                const batch = skus.slice(i, i + batchSize);
                try {
                    // console.log('batch data for ns-product-bundle..............',batch);
                  const data = await ProductDataService.getProductData(batch);
                //   console.log('response data for ns-product-bundle........',data.products);
                  if (data && data.products) {
                    results.push(...data.products);
                  }
                } catch (err) {
                  console.log("Failed to load batch,", err);
                }
              }
          
              this.localProducts = results.map((product) => {
                return {
                  ...product,
                  SKU: product.sku,
                };
              });
          
              this.productsLoaded = true;

              // Call performFurtherActions after setting localProducts
        this.performFurtherActions();

            } catch (e) {
              console.log("Failed to load products,", e);
            }
          }
        } catch (e) {
          console.log("Failed to load products,", e);
        }
      }

    /**
     * Calculates bundle total from price attribute of all product component children
     */
    _updateBundlePrice() {
        let children = this.shadowRoot.querySelectorAll("ns-product-small");
        let totalPrice = 0;
        let totalOutOfStock = 0;
        children.forEach(product => {
            totalPrice += product.price;
            if (product.notAvailable || (product.__data.product && product.__data.product.status !== 'RELEASED_FOR_SALE' && product.__data.product.status !== '')) {
                totalOutOfStock++;
            }
        });
        this.productOutOfStock = (totalOutOfStock > 0) ? true : false;
        if (!Number.isNaN(totalPrice)) {
            this.bundleTotal = totalPrice;
        }
    }

}
customElements.define(NsProductBundle.is, NsProductBundle);
